import { Id, Policy, PolicyRule } from 'src/types'

interface InitialValuesProps {
  organization_id: Id
  policy_id: Id
}

export function getInitialValuesPolicy({
  policy_id = null,
  organization_id = null
}: InitialValuesProps): Policy {
  return {
    active: true,
    description: '',
    name: '',
    organization_id,
    policy_expense_limits: [],
    policy_id,
    policy_rules: []
  }
}

export function getInitialValuesPolicyRules({
  policy_id = null
}: {
  policy_id: Id
}): PolicyRule {
  return {
    active: true,
    description: '',
    disable_advance_retroactive: false,
    enable_advance: true,
    enable_billing_observation: true,
    enable_budget: true,
    enable_bus: false,
    enable_check_receipt: false,
    enable_checkin: true,
    enable_def_custom_contract: false,
    enable_def_custom_target: false,
    enable_enforce_additional_info: false,
    enable_flight: true,
    enable_hotel: true,
    enable_itinerary: true,
    enable_nps: true,
    enable_qr_code_check_diferent_vat: false,
    enable_qr_code_check_vat: false,
    enable_qr_code: true,
    enable_receipt_antifraud: false,
    enable_resume: true,
    enable_standard_billing: true,
    enable_standard_sharing: true,
    enable_track: false,
    enable_vehicle_rent: true,
    forward_to_expense: true,
    name: '',
    force_image: false,
    policy_id,
    policy_request_air_rule: null,
    policy_request_budget_rule: null,
    policy_request_general_rule: null,
    policy_request_hotel_rule: null,
    policy_request_vehicle_rule: null,
    policy_rule_id: null,
    qrcode_retroative_date: false,
    qrcode_show_antifraud: false,
    reason_id: null
  }
}
